import script from "./performance-appraisal-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./performance-appraisal-modal.vue?vue&type=script&setup=true&lang=js"

import "./performance-appraisal-modal.vue?vue&type=style&index=0&id=8aa4e0da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aa4e0da"]])

export default __exports__